import {
  GET_ERROR,
  GET_COUNTS,
  INCOME_LOADING,
  INCOME_REPORT,
  INCOME_ERROR,
} from "../actions/types";

const initialState = {
  userCount: null,
  printerCount: null,
  printerIncome: [],
  // The admin dashboard compares the range with the period before it
  previousIncome: [],
  // The range day by day: { days, kiosks } (GET /api/monitoring/income/daily), or
  // why there is none. A range of one day comes with the days before it (range.daily).
  dailyIncome: null,
  dailyError: null,
  // The range printerIncome belongs to, and when it was loaded
  range: null,
  updatedAt: null,
  incomeError: false,
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_COUNTS:
      return {
        ...state,
        userCount: payload.userCount,
        printerCount: payload.printerCount,
      };
    case INCOME_LOADING:
      return {
        ...state,
        loading: true,
        incomeError: false,
      };
    case INCOME_REPORT:
      return {
        ...state,
        loading: false,
        printerIncome: payload.income,
        previousIncome: payload.previous,
        dailyIncome: payload.daily.report || null,
        dailyError: payload.daily.error || null,
        range: payload.range,
        updatedAt: payload.updatedAt,
        incomeError: false,
      };
    case INCOME_ERROR:
      return {
        ...state,
        loading: false,
        incomeError: true,
      };
    default:
      return state;
  }
}
